import {POST} from "@/services/gateway";

const editDomain = (data) => {
  return POST('dashboard/domain/update', data);
}

export {
  editDomain,
}
